import { browserLogger } from '@widget/utils/datadog';

import type { SalesTimeslotsMutationData, SalesTimeslotsMutationInput } from './types';
import type { ApiResponse, LeadDataResponse } from '@widget/api/types';

export const SalesTimeslotsQueryKey = {
  main(leadId: LeadDataResponse['id']) {
    return ['/api-widget', 'lead', leadId, 'sales_timeslots'];
  },
};

export const SalesTimeslotsMutationFn = {
  async main({ id, salesStartTime }: SalesTimeslotsMutationInput) {
    try {
      const response = await fetch(SalesTimeslotsQueryKey.main(id).join('/'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ salesStartTime }),
      });

      if (!response.ok) {
        throw new Error('sales_timeslots request is not ok');
      }

      const result = (await response.json()) as ApiResponse<SalesTimeslotsMutationData>;

      if (result.error) {
        throw new Error('sales_timeslots error result');
      }

      return result.data;
    } catch (error) {
      browserLogger.error(error, 'sales_timeslots book error');
      throw error;
    }
  },
};
